import { customAxios, IDUSUARIO, FDV_URL } from '../constants';
import { evalAction, serverError } from './actionError';

export default function(numeroFicha = '',numeroProforma = '') {
    const config = {
    headers: {
      codIdUsuario: IDUSUARIO,
    },
  };


  const request = customAxios.get(`${FDV_URL}/ficha-venta/fichas-ventas/${numeroFicha}/proformas/${numeroProforma}/bonos-proforma`, config)
                                .then(({ data }) => evalAction(data, 'bonoProforma'))
                                .catch(error => serverError(error, 'bonoProforma'));
  return request;


}


// WEBPACK FOOTER //
// ./src/utils/getBonos.js